import { makeAutoObservable } from 'mobx';
import { CreateEventRequestEvent, EventsApi, LegacyEventsApi } from '@coretava/api/events-service';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { v4 as uuidV4 } from 'uuid';
import { AnalyticsFactory } from '@gamiphy/analytics';

class EventsStore {
  constructor() {
    makeAutoObservable(this);
  }

  public get legacyApi(): LegacyEventsApi {
    return new LegacyEventsApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
      accessToken: UserStore.token,
    });
  }

  private get api(): EventsApi {
    return new EventsApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
      accessToken: UserStore.token,
    });
  }

  public async createEvent(event: CreateEventRequestEvent): Promise<void> {
    const analytics = await AnalyticsFactory.getInstance();

    await this.api.eventsControllerCreate(AppStore.app.id, {
      event,
      id: uuidV4(),
      customerId: analytics.customerId,
      createdAt: new Date().toISOString(),
    });
  }
}

export default new EventsStore();
